import _objectWithoutPropertiesLoose from "@babel/runtime/helpers/esm/objectWithoutPropertiesLoose";
const _excluded = ["as", "children", "dividerColor", "alignItems", "gap"];
import styled from 'styled-components';
import { LayoutHorizontal } from './LayoutHorizontal';
import { makeCustomProperty, makeBorderCustomProperty } from './utils';
import { forwardRef } from 'react';
import { jsx as _jsx } from "react/jsx-runtime";
const DividerContainer = styled(LayoutHorizontal).withConfig({
  displayName: "LayoutDividerHorizontal__DividerContainer",
  componentId: "sc-148z7rk-0"
})(["", " column-gap:calc(var(--layout-lib-space-gap) * 2);> *{position:relative;}>:not(:last-child,:empty)::after{", " ", " content:'';display:block;inset-block:0;inset-inline-end:calc( var(--layout-lib-space-gap) * -1 - var(--layout-lib-border-width) );position:absolute;height:100%;z-index:1;}"], ({
  $gap
}) => `--layout-lib-space-gap: ${makeCustomProperty($gap)};`, ({
  $gap
}) => `--layout-lib-space-gap: ${makeCustomProperty($gap)};`, ({
  $dividerColor
}) => $dividerColor && `border-inline-end: ${makeBorderCustomProperty($dividerColor)};`);
export const LayoutDividerHorizontal = /*#__PURE__*/forwardRef((_ref, ref) => {
  let {
      as,
      children,
      dividerColor = 'border',
      alignItems = 'center',
      gap = 'space'
    } = _ref,
    rest = _objectWithoutPropertiesLoose(_ref, _excluded);
  return /*#__PURE__*/_jsx(DividerContainer, Object.assign({}, rest, {
    $dividerColor: dividerColor,
    $gap: gap,
    alignItems: alignItems,
    forwardedAs: as,
    ref: ref,
    children: children
  }));
});